/* src/app/forms/authentication/authentication.component.scss */
.button-big {
  width: 300px;
}
.content-container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: 100%;
  flex-direction: column;
  gap: 16px;
}
iframe {
  height: 50%;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
img {
  height: 100%;
  width: 100%;
  border-radius: 3px;
}
.card-data-image {
  height: 300px;
  width: 300px;
  object-fit: contain;
}
.card-data-footer {
  font-size: 80%;
  font-family: cursive;
}
.marketplace {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.snk-auth {
  display: flex;
  flex-direction: row;
  gap: 6px;
}
.market-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.market-avatar {
  background: #fff;
  border: 1px solid #eee;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}
.filtros-rapidos {
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.search-box {
  min-width: 200px;
  max-width: 280px;
}
.search-box input {
  border-radius: 2px;
}
.button-container {
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
}
/*# sourceMappingURL=authentication.component.css.map */
